import { clientPortalAccountsApi } from "@/api";
import { withLocalErrorHandling } from "@/api/middleware/errorMiddleware";
import { PortalAccountApi } from "@/common/components/portal-access/portalAccess.types";

/**
 * The client flavour of the shared portal-access API adapter. Clients additionally offer the
 * withdraw and remove-user actions, and the invitation carries the selected address and the
 * ID-document details (Ausweisdaten).
 */
export function createClientPortalAccountApi(clientId: string): PortalAccountApi {
  return {
    getStatus: () => clientPortalAccountsApi.getClientPortalAccountStatus({ clientId }),
    sendInvitation: (request) =>
      clientPortalAccountsApi.sendPortalInvitation(
        { clientId, sendPortalInvitationRequest: request },
        withLocalErrorHandling
      ),
    resendInvitation: () => clientPortalAccountsApi.resendPortalInvitation({ clientId }, withLocalErrorHandling),
    lock: () => clientPortalAccountsApi.lockPortalAccount({ clientId }, withLocalErrorHandling),
    unlock: () => clientPortalAccountsApi.unlockPortalAccount({ clientId }, withLocalErrorHandling),
    sendPasswordReset: () => clientPortalAccountsApi.sendPortalPasswordReset({ clientId }, withLocalErrorHandling),
    withdrawInvitation: () => clientPortalAccountsApi.withdrawPortalInvitation({ clientId }, withLocalErrorHandling),
    removeUser: () => clientPortalAccountsApi.removePortalUser({ clientId }, withLocalErrorHandling),
  };
}
